import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://github.com/shaheen-ahmad2601" target="_blank" rel="noreferrer">
                <i className="fa fa-github fa-2x" />
              </a>
              <a
                href="https://www.linkedin.com/in/shaheen-ahmad-khan/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa fa-linkedin fa-2x" />
              </a>
              <a href="https://twitter.com/ronie_____" target="_blank" rel="noreferrer">
                <i className="fa fa-twitter fa-2x" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hi, I'M{" "}
              <span className="highlighted-text">
                Shaheen <span className="last-name">Ahmad</span>
              </span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Full Stack MERN Developer",
                    1000,
                    "A Computer Science Geek",
                    1000,
                    "Experienced DevOps Engineer",
                    1000,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              ❝ A driven and enthusiastic Full Stack Developer with over 2 years
              <br /> of experience in developing dynamic web applications using
              MERN stack. ❞
            </span>
          </div>

          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              Hire Me
            </button>

            <a
              href="https://drive.google.com/file/d/11RsmGM5rY3suLIMJyBo6hTTF_skOdp4R/view?usp=sharing"
              download
              target="_blank"
              rel="noreferrer"
            >
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
